export const keyMapper = {
  provider_title: 'title',
  provider: 'name',
};
